<template>
    <v-container>
        <div class="titulo my-4 px-4">
            <h1 class="font-weight-bold" :class="esMovil ? 'text-h6' : 'text-h5'">
                Privacidad
            </h1>
        </div>
    </v-container>
</template>
<script>
export default {
    name: "InfoPrivacidad",
    data: () => ({}),
    computed: {
        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },
};
</script>
